var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7328 8.90401C26.7328 6.80401 25.0248 5.09601 22.9248 5.09601H5.11675C3.01675 5.09601 1.30875 6.80401 1.30875 8.90401V19.096C1.30875 21.196 3.01675 22.904 5.11675 22.904H22.9248C25.0248 22.904 26.7328 21.196 26.7328 19.096V8.90401ZM11.4728 18.284V8.73601L18.7248 13.524L11.4728 18.284Z",
    fill: "#476A89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialYoutube);
export default __webpack_public_path__ + "static/media/icon-social-youtube.296c582f647b6ce8129bf46d0ccca26a.svg";
export { ForwardRef as ReactComponent };